import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { SnackbarProvider } from "notistack";
ReactDOM.render(
  <Router>
    <SnackbarProvider>
      <App />
    </SnackbarProvider>
  </Router>,
  document.getElementById("root")
);
